exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clinic-schedule__title[data-v-33409c30]{margin-top:40px;font-size:32px;color:var(--theme-text-color);font-weight:800;letter-spacing:.5px;line-height:1.31;margin-bottom:25px}.clinic-schedule__hours input[data-v-33409c30]{width:40%}.clinic-schedule__button-link[data-v-33409c30]{text-decoration:none;font-weight:700;font-size:13px;transition:color .2s}.clinic-schedule__button-link[data-v-33409c30]:hover{color:var(--theme-color)!important}.clinic-schedule__button-link .wabident[data-v-33409c30]{margin:0 5px;font-size:28px}", ""]);

// exports
